import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  PickTicketPickerCriteriaBean,
  PickTicketPickerDetailsPrintRequest,
} from "../ds/ds.js";
import {
  AlertToolBox,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import { isEmptyArray, isEmptyString } from "../gui_components/Util.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupInvoiceModule,
  PopupPickTicketModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class PickTicketPickerDetails extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "PickTicket Picker Detail Lists Inquiry",
      isShowExitButton: true,
      isShowExecuteButton: true,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      error_list: [],
      criteria: new PickTicketPickerCriteriaBean(),
      isInquiryDatasFound: false,
      inquiryDataList: [],
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      moduleForPopup: [],
      isDisableFields: false,
      isShowInvoiceModule: false,
      isShowCustomerModule: false,
      isShowPickticketModule: false,
      isShowSalesModule: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    this.NewDate();
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  NewDate = () => {
    let date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth();
    let fromDate = new Date(y, m, 1).toLocaleDateString("sv-SE");
    let ToDate = new Date().toLocaleDateString("sv-SE");
    let criteria = this.state.criteria;
    criteria.fromPickedDate = fromDate;
    criteria.toPickedDate = ToDate;
    this.setState({ criteria: criteria });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage();
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadPickTicketPickerDetail(criteria);
  };
  loadPickTicketPickerDetail = (listRequest) => {
    if (
      SecurityAccessManager.PickTicketPickerDetailListInquiry_IsAccessible()
    ) {
      ReportService.getPickTicketPickerDetails(
        listRequest,
        this.loadPickTicketPickerDetailPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadPickTicketPickerDetailPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.pickerDetailsResult != null) {
      let pickTicketDetails = new Array();
      if (!isEmptyArray(response.data.pickerDetailsResult.pickerDetails)) {
        pickTicketDetails = response.data.pickerDetailsResult.pickerDetails;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        inquiryDataList: pickTicketDetails,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error" + error);
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  clearCriteria = () => {
    let criteria = new PickTicketPickerCriteriaBean();
    criteria.companyCode = this.companyCode;
    let date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth();
    let fromDate = new Date(y, m, 1).toLocaleDateString("sv-SE");
    let ToDate = new Date().toLocaleDateString("sv-SE");
    criteria.fromPickedDate = fromDate;
    criteria.toPickedDate = ToDate;
    this.setState({ criteria: criteria });
    this.hideAlertCallBack();
  };
  reset = () => {
    let criteria = new PickTicketPickerCriteriaBean();
    let date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth();
    let fromDate = new Date(y, m, 1).toLocaleDateString("sv-SE");
    let ToDate = new Date().toLocaleDateString("sv-SE");
    criteria.fromPickedDate = fromDate;
    criteria.toPickedDate = ToDate;
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isDisableFields: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowClearCriteriaButton: true,
    });
    this.hideAlertCallBack();
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowAlert: isDisplayed,
      error_list: [],
    });
  };
  generatePDF = () => {
    this.generatePickTicketPickerDetailReport(1);
  };
  generateExcel = () => {
    this.generatePickTicketPickerDetailReport(2);
  };
  generatePickTicketPickerDetailReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new PickTicketPickerDetailsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    if (!isEmptyArray(this.state.inquiryDataList)) {
      if (reportBean.reportType == 1) {
        if (
          SecurityAccessManager.PickTicketPickerDetailListInquiryPDFReport_IsAccessible()
        ) {
          ReportService.generatePickTicketPickerDetailsPrintReport(
            listRequest,
            this.generatePickTicketPickerDetailPageResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(2);
        }
      } else if (reportBean.reportType == 2) {
        if (
          SecurityAccessManager.PickTicketPickerDetailListInquiryExcelReport_IsAccessible()
        ) {
          ReportService.generatePickTicketPickerDetailsPrintReport(
            listRequest,
            this.generatePickTicketPickerDetailPageResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(3);
        }
      }
    }
  };
  generatePickTicketPickerDetailPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCustomerModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPickTicketModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPickticketModule: true,
          moduleForPopup: (
            <PopupPickTicketModule
              pickTicketCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewInvoiceModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowSalesModule: isOpen,
      isShowPickticketModule: isOpen,
      moduleForPopup: [],
    });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("PickTicket#", "pickTicketNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPickTicketModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PickTicket Date", "pickTicketDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer Name", "customerName", true)
        .setStyleDetails("left", "6", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesOrder#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewSalesModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PickedBy", "pickerName", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Logistic Method#", "logisticMethodCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          hideAlertCallBack={this.hideAlertCallBack}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          clearCriteria={this.clearCriteria}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          reset={this.reset}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView {...this.state} onChange={this.onChange} />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowCustomerModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel0"}
          closeOnEsc={false}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowSalesModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel0"}
          closeOnEsc={false}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowPickticketModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel0"}
          closeOnEsc={false}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowInvoiceModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel0"}
          closeOnEsc={false}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  let criteria = props.criteria;
  return (
    <div>
      <Row>
        <Col sm="1">
          <FormLabel>Picked By</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="pickedBy"
            onChange={onChange}
            value={criteria.pickedBy}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>From PickedDate</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="fromPickedDate"
            value={criteria.fromPickedDate}
            onChange={onChange}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>To PickedDate</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="toPickedDate"
            value={criteria.toPickedDate}
            onChange={onChange}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
      </Row>
    </div>
  );
}

function PickTicketPickerDetailInquiry(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App"></div>
      <PickTicketPickerDetails {...props} name="" />
      <br />
    </div>
  );
}
export default PickTicketPickerDetailInquiry;
